// @flow

import React from 'react';
import { usePropsValidation } from '../validation/runtime-checks/index.js';
import { types as t } from '../validation/runtime-checks/prop-spec.js';
import { illustrationColor } from '../designSystem.js';

export function TAKBenchmark(props: {| code: string |}) {
  const { failedValidation } = usePropsValidation(props, TAKBenchmark);
  if (failedValidation) return null;

  return (
    <>
      <p
        style={{
          fontWeight: 600,
          color: illustrationColor.regentGray,
          fontSize: 16,
          lineHeight: '22px',
          marginBottom: 16,
        }}
      >
        {props.code}
      </p>
    </>
  );
}

TAKBenchmark.spec = {
  code: t.string,
};
